export default "__VITE_ASSET__o5z_UYqA__"